import React, { useState } from 'react';
import Pluralize from 'react-pluralize';

import { usePermission } from '@sbu/hooks.permissions';
import { Button } from '@sumologic/yama-ds-components';

import css from './EntitiesBulkActions.module.scss';
import { EntitiesCriticalityEditor } from './EntitiesCriticalityEditor';
import { EntitiesSuppressionEditor } from './EntitiesSuppressionEditor';
import { EntitiesTagEditor } from './EntitiesTagEditor';

interface EntitiesBulkActionsProps {
  entityIds: string[];
  total: number;
}

export const EntitiesBulkActions = ({
  entityIds,
  total,
}: EntitiesBulkActionsProps) => {
  const { length } = entityIds;
  const [tagEditorVisible, setTagEditorVisible] = useState(false);
  const [suppressionEditorVisible, setSuppressionEditorVisible] =
    useState(false);
  const canSuppress = !!usePermission('can_manage_whitelisted_entities');
  const [criticalityEditorVisible, setCriticalityEditorVisible] =
    useState(false);

  return (
    <div className={css.bulkActions} data-sumo-test='entities-bulk-actions'>
      <Button
        className={css.bulkAction}
        color='secondary'
        onClick={() => setTagEditorVisible(!tagEditorVisible)}
        size='small'
      >
        Change Tags
      </Button>
      {canSuppress && (
        <Button
          className={css.bulkAction}
          color='secondary'
          onClick={() => setSuppressionEditorVisible(!suppressionEditorVisible)}
          size='small'
        >
          Change Suppression
        </Button>
      )}
      <Button
        className={css.bulkAction}
        color='secondary'
        onClick={() => setCriticalityEditorVisible(!criticalityEditorVisible)}
        size='small'
      >
        Change Criticality
      </Button>
      {!!length && (
        <div className={css.selectionLabel}>
          {`${length.toLocaleString()} of ${total.toLocaleString()} `}
          <Pluralize
            count={total}
            plural='Entities'
            showCount={false}
            singular='Entity'
          />{' '}
          <Pluralize
            count={length}
            plural='are'
            showCount={false}
            singular='is'
          />{' '}
          selected.
        </div>
      )}
      {tagEditorVisible && (
        <EntitiesTagEditor
          entityIds={entityIds}
          onClose={() => setTagEditorVisible(false)}
        />
      )}
      {suppressionEditorVisible && (
        <EntitiesSuppressionEditor
          entityIds={entityIds}
          onClose={() => setSuppressionEditorVisible(false)}
        />
      )}
      {criticalityEditorVisible && (
        <EntitiesCriticalityEditor
          entityIds={entityIds}
          onClose={() => setCriticalityEditorVisible(false)}
        />
      )}
    </div>
  );
};
